import { render, staticRenderFns } from "./ReadOnlyField.vue?vue&type=template&id=33161925&"
import script from "./ReadOnlyField.vue?vue&type=script&lang=ts&"
export * from "./ReadOnlyField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports